/**
 * The header breadcrumb of a typed page or a type page: where it sits in the
 * Pages tree, as the header shows a page's folders. The walk itself is the
 * shared crumb (`trackerPageCrumb`, `trackerPageCrumbFolders`) the pages draw
 * above their titles; this only turns it into header crumbs. An unplaced typed
 * page sits under its type, whose crumb opens the type page.
 */

export interface PagesPathCrumb {
  id: string;
  label: string;
  /** Set on the crumb naming a type; it opens that type's page. */
  typeId?: string;
}

export interface PagesHeaderPath {
  crumbs: PagesPathCrumb[];
  title: string;
}

const ancestorCrumbs = (ancestors: readonly string[]): PagesPathCrumb[] => ancestors.map((label, index) => ({ id: `ancestor-${index}`, label }));

export function typedPageHeaderPath(
  crumb: { ancestors: readonly string[]; underType: boolean },
  type: { typeId: string; name: string },
  title: string,
): PagesHeaderPath {
  return {
    crumbs: [
      ...ancestorCrumbs(crumb.ancestors),
      ...(crumb.underType ? [{ id: `type-${type.typeId}`, label: type.name, typeId: type.typeId }] : []),
    ],
    title: title.trim() || 'Untitled',
  };
}

export function typePageHeaderPath(ancestors: readonly string[], typeName: string): PagesHeaderPath {
  return { crumbs: ancestorCrumbs(ancestors), title: typeName };
}
